import { VAlert } from 'vuetify/lib/components/VAlert';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[(!_vm.isValidClientGroupId)?_c(VAlert,{attrs:{"type":"warning","outlined":""}},[_vm._v(_vm._s(_vm.$t('general.invalidUrl')))]):_c('SubBubbleAgreementsContainer',{attrs:{"client-group-id":_vm.clientGroupIdFormatted}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }